<template lang="pug">
v-container
  v-card.pointer( v-for="item in personalAccountContainer" :key="item.id" class="mx-auto mb-1" max-width="400" @click.native="goNext(item)" )
    v-card-title {{ item.title }}
      span.ellipse.mg-act( v-if="item.id == 1 && hasNewAct" )
      span.ellipse.mg-act( v-if="item.id == 2 && hasNewAgreement" )

</template>
<script>
import { mapState, mapActions } from "vuex";


export default {
  data: () => ({
    personalAccountContainer: [
      {
        id: 0,
        title: "Личные данные"
      },
      {
        id: 1,
        title: "Акты"
      },
      {
        id: 2,
        title: "Договор"
      }
    ]
  }),

  computed: {
    ...mapState("user", ['personalData']),
    ...mapState("act", ['notViewedMyAct']),
    ...mapState("agreement", ['notViewedMyAgreement']),

    hasNewAct() {
      return this.notViewedMyAct && this.notViewedMyAct.length
    },

    hasNewAgreement() {
      return this.notViewedMyAgreement && this.notViewedMyAgreement.length
    }
  },

  beforeMount() {
    this.loadUser()
  },

  methods: {
    ...mapActions("user", ['loadPersonalData', 'loadUser']),
    goNext(item){
      switch(item.title) {
        case "Личные данные":
          this.loadPersonalData().then(() => {
            this.$router.push(`/personalAccount/personalData`)
          })
          break
        case "Акты":
          this.$router.push(`/personalAccount/yearsAct`)
          break
        case "Договор":
          this.$router.push(`/personalAccount/agreementYears`)
          break
        default:
          return ""
      }
    }
  }
}
</script>
<style scoped>
.ellipse {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: #ED0E51;
  position: relative;
  background-image: url(/src/layouts/img/red-circle.gif);
  background-size: cover;
}
.mg-act {
  margin-left: 5px;
  margin-bottom: 17px;
}
</style>